import { useCallback, useContext } from 'react';
import { CSSTransition } from 'react-transition-group';
import { BackButtonWrapper, CloseButtonWrapper, DrawerInner, Header, HorizontalDivider, Title, Wrapper, } from './Drawer.styles';
import { ModalContext } from './ModalContext';
export var DrawerPosition;
(function (DrawerPosition) {
    DrawerPosition["RIGHT"] = "right";
    DrawerPosition["BOTTOM"] = "bottom";
})(DrawerPosition || (DrawerPosition = {}));
/**
 *
 */
export const Drawer = ({ children, backgroundColor = 'var(--player-drawer-background)', className = '', color = 'var(--player-drawer-font-color)', maxHeight = '80%', minHeight = '20%', maxWidth = '100%', position = DrawerPosition.BOTTOM, overflow = 'visible', padding = '20px', paddingBottom = '20px', drawerScrollContainerRef, headerProps, testId, }) => {
    const { closeButton, backButton, title, titleId } = useContext(ModalContext);
    const onClickStopPropagation = useCallback((e) => e.stopPropagation(), []);
    return (<CSSTransition appear={true} classNames={`transition`} in={true} mountOnEnter={true} timeout={250}>
      <Wrapper overflowY={className.includes('cy-products-modal') ? 'visible' : 'auto'} onClick={onClickStopPropagation} role="none" backgroundColor={backgroundColor} color={color} minHeight={minHeight} maxHeight={maxHeight} maxWidth={maxWidth} position={position} className={`${className} cy-drawer`}>
        {(backButton || title || closeButton) && (<Header onClick={onClickStopPropagation} role="none" {...headerProps}>
            <BackButtonWrapper>{backButton}</BackButtonWrapper>

            <Title id={titleId}>{title}</Title>

            <CloseButtonWrapper>{closeButton}</CloseButtonWrapper>
          </Header>)}

        <HorizontalDivider />
        <DrawerInner className={`cy-drawer-inner`} ref={drawerScrollContainerRef} data-testid={testId} padding={padding} paddingBottom={paddingBottom} overflow={overflow}>
          {children}
        </DrawerInner>
      </Wrapper>
    </CSSTransition>);
};
